// Contract radar (design 2a / product rule #7). Turns a club-contract expiry
// date into an urgency pill state. Thresholds are configurable constants.
import moment from "moment";

export const EXPIRING_SOON_DAYS = 90;

// Returns one of: 'expired' | 'soon' | 'ok' | 'none'
export const getContractState = (expiresOn) => {
  if (!expiresOn) return "none";
  const end = moment(expiresOn, moment.ISO_8601, true).isValid()
    ? moment(expiresOn)
    : moment(new Date(expiresOn));
  if (!end.isValid()) return "none";
  const days = end.startOf("day").diff(moment().startOf("day"), "days");
  if (days < 0) return "expired";
  if (days <= EXPIRING_SOON_DAYS) return "soon";
  return "ok";
};

// Number of days until expiry (null when no/invalid date). Negative = past.
export const daysToExpiry = (expiresOn) => {
  if (!expiresOn) return null;
  const end = moment(new Date(expiresOn));
  if (!end.isValid()) return null;
  return end.startOf("day").diff(moment().startOf("day"), "days");
};

// Presentational descriptor for the pill: label + Tailwind classes.
export const getContractPill = (expiresOn) => {
  const state = getContractState(expiresOn);
  switch (state) {
    case "expired":
      return { state, label: "Contract expired", className: "bg-[#FEE2E2] text-[#B91C1C]", tone: "danger" };
    case "soon": {
      const d = daysToExpiry(expiresOn);
      return { state, label: `Expires in ${d} day${d === 1 ? "" : "s"}`, className: "bg-[#FEF3C7] text-[#92400E]", tone: "warn" };
    }
    case "ok":
      return { state, label: `Expires ${moment(new Date(expiresOn)).format("MMM YYYY")}`, className: "bg-[#EAEFF5] text-[#475569]", tone: "neutral" };
    default:
      return { state: "none", label: "No contract data", className: "bg-white border border-dashed border-[#C4CEDA] text-[#64748B]", tone: "none" };
  }
};

export default getContractPill;
